import type { DateRange, RelativeDateRange } from './DateRangeFilterType';
import { DATE_UNITS, DATE_RANGE_TYPE } from './DateRangeFilterType';
import { makeRelativeDateRange } from './DateRangeFilterUtils';

export const DEFAULT_VALUE: DateRange = {
  type: DATE_RANGE_TYPE.RELATIVE,
  amount: 24,
  unit: DATE_UNITS.HOURS,
};

export const RELATIVE_DATE_RANGES: Array<RelativeDateRange> = [
  makeRelativeDateRange(24, DATE_UNITS.HOURS),
  makeRelativeDateRange(7, DATE_UNITS.DAYS),
  makeRelativeDateRange(15, DATE_UNITS.DAYS),
  makeRelativeDateRange(30, DATE_UNITS.DAYS),
  makeRelativeDateRange(3, DATE_UNITS.MONTHS),
  makeRelativeDateRange(6, DATE_UNITS.MONTHS),
  makeRelativeDateRange(12, DATE_UNITS.MONTHS),
];
